define('modules/form_editor/models/custom_date',['require','exports','module','./base_form_element'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element");

  module.exports = BaseFormElement.extend({
    name: "custom:date",
    defaultValues: {
      firstOptionInvalid: true,
      ageLimit: 0,
      dateOrder: "Year/Month/Day",
      separator: "/",
      invalidDateMessage: "",
      invalidDateAgeLimitMessage: "",
      fillWithZero: false
    },

    validate: function(attrs) {
      if (isNaN(attrs.ageLimit) || attrs.ageLimit < 0) return new Error();
    }
  });
});

